import POCDetailCard from '../poc-detail-card';
import { Button } from '@components/base';
import css from './index.module.scss';
import { useState } from 'react';
import { sendInvitationToPoc } from '@services/customer.service';
import notify from '@helpers/toastify-helper';
import { DeletePrompt } from '@components/common';
import { Poc } from '@helpers/types/point-of-contact';
import moment from 'moment';

interface POCDetailInvitationCardProps {
  poc: Poc;
  fetchCustomerInfo?: () => Promise<void>;
}

const POCDetailInvitationCard = (props: POCDetailInvitationCardProps) => {
  const { poc, fetchCustomerInfo } = props;
  const [cardDetails, setCardDetails] = useState({
    isLoading: false,
    openDisclaimer: false,
    latestDate: poc.recent_email_sent_date
  });
  const { isLoading, openDisclaimer, latestDate } = cardDetails;

  const sendInvitation = async () => {
    setCardDetails((prev) => ({
      ...prev,
      isLoading: true
    }));

    const response = await sendInvitationToPoc(poc.user_id);
    if (response.success) {
      setCardDetails((prev) => ({
        ...prev,
        isLoading: false,
        latestDate: response.data?.sent_date || new Date().toISOString()
      }));
      fetchCustomerInfo?.();
      notify({
        severity: 'success',
        message: 'Invitation sent successfully'
      });
    } else {
      setCardDetails((prev) => ({
        ...prev,
        isLoading: false
      }));
      notify({
        severity: 'error',
        message: response.data?.message || 'Failed to send invitation'
      });
    }
  };

  const handleButtonClick = () => {
    setCardDetails((prev) => ({
      ...prev,
      openDisclaimer: true
    }));
  };
  const getConfirmationMessage = () => {
    const fullName = `${poc?.given_name ?? ''} ${poc?.family_name ?? ''}`.trim();

    if (latestDate) {
      return `An invitation was already sent on ${moment(latestDate).format(
        'DD-MMM-YYYY'
      )}. Do you still want to give platform access to ${fullName}?`;
    }

    return `Do you want to give platform access to ${fullName}?`;
  };

  return (
    <div className={css.pocDetailInvitationCard}>
      <POCDetailCard
        name={`${poc.given_name} ${poc.family_name}`}
        email={poc.email}
        phoneNumber={poc.phone_number}
      />
      <Button
        variant="outlined-secondary"
        className={css.invitationButton}
        onClick={handleButtonClick}
        disabled={isLoading || !poc.first_time_login}
      >
        {poc.first_time_login
          ? 'Send Invitation'
          : isLoading
          ? 'Sending...'
          : latestDate
          ? 'Resend Invitation'
          : 'Send Invitation'}
      </Button>
      {openDisclaimer && (
        <DeletePrompt
          open={openDisclaimer}
          onClose={() =>
            setCardDetails((prev) => ({
              ...prev,
              openDisclaimer: false
            }))
          }
          onConfirm={() => {
            sendInvitation();
            setCardDetails((prev) => ({
              ...prev,
              openDisclaimer: false
            }));
          }}
          message={getConfirmationMessage()}
        />
      )}
    </div>
  );
};

export default POCDetailInvitationCard;
